import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { encryptData, obterCorPorStatus } from '../utils';
import Moment from 'moment';
import { useNavigate } from 'react-router-dom';
import CustomChip from './CustomChip';

export default function PainelNotaItem({ nota }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  const handleClick = () => {
    const data = {
      contrato:
        nota.codigo_contrato == null
          ? nota.codigo_ordem_compra
          : nota.codigo_contrato,
      cnpj: nota.cnpj_prestador_servico,
      contrato_dts: nota.contrato_dts,
      is_contract:
        nota.codigo_contrato !== null &&
        nota.codigo_contrato !== undefined &&
        nota.codigo_contrato !== '',
      gestor:
        nota.ordem_servico && nota.ordem_servico.length > 0
          ? nota.ordem_servico[0].gestor_tecnico
          : '',
    };

    if (
      (nota && nota.situacao_nf == 'RASCUNHO') ||
      nota.situacao_nf == 'PENDENCIA DO FORNECEDOR'
    ) {
      data.nota_id = nota.id;
      const encrypted = encryptData(JSON.stringify(data));
      navigate(`/dashboard/nota/${encrypted}`);
    } else {
      const encrypted = encryptData(JSON.stringify(data));
      navigate(`/dashboard/notas/${encrypted}`);
    }
  };

  return (
    <Grid item sm={6}>
      <table
        className="app_table"
        style={{ cursor: 'pointer' }}
        onClick={handleClick}
      >
        <thead
          style={{
            color: theme.palette.primary.main,
            borderTop: `8px solid ${theme.palette.primary.light}`,
          }}
        >
          <tr>
            <th style={{ width: '50%', backgroundColor: '#E7F0FF' }}>
              <strong style={{ color: '#006EB3' }}>Nº da nota fiscal:</strong>{' '}
              {nota.numero_nf}
            </th>
            <th style={{ width: '50%', backgroundColor: '#E7F0FF' }}>
              <strong style={{ color: '#006EB3' }}>Nº do processo:</strong>{' '}
              {nota.numero_processo_fluig}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr style={{ background: 'white' }}>
            <td colSpan={2} style={{ paddingLeft: '1.2rem' }}>
              {nota && nota.codigo_contrato ? (
                <div>
                  <strong style={{ color: '#919191' }}>Contrato:</strong>
                  <span style={{ color: '#006EB3', paddingLeft: 10 }}>
                    {nota.codigo_contrato}
                  </span>
                </div>
              ) : (
                <div>
                  <strong style={{ color: '#919191' }}>Pedido:</strong>
                  <span style={{ color: '#006EB3', paddingLeft: 10 }}>
                    {nota.codigo_ordem_compra}
                  </span>
                </div>
              )}
            </td>
          </tr>
          <tr style={{ background: 'white' }}>
            <td style={{ paddingLeft: '1.2rem' }}>
              <strong style={{ color: '#919191' }}>Data de emissão:</strong>
              <span style={{ color: '#006EB3', paddingLeft: 10 }}>
                {Moment(nota.data_emissao_nf).format('DD/MM/YYYY')}
              </span>
            </td>
            <td style={{ paddingLeft: '1.2rem' }}>
              <strong style={{ color: '#919191' }}>Valor:</strong>
              <span style={{ color: '#006EB3', paddingLeft: 10 }}>
                {formatter.format(nota.valor_servico)}
              </span>
            </td>
          </tr>
          <tr style={{ background: 'white' }}>
            <td style={{ paddingLeft: '1.2rem' }}>
              {/* <CustomChip label={nota.situacao_nf} status={nota.situacao_nf} /> */}
              <Button
                style={{
                  borderRadius: 20,
                  width: '70%',
                  fontSize: 10,
                }}
                variant="outlined"
                color={obterCorPorStatus(nota.situacao_nf)}
              >
                {nota.situacao_nf}
              </Button>
            </td>
            <td style={{ paddingLeft: '1.2rem' }}>
              <strong style={{ color: '#919191' }}>Observação:</strong>
              <span style={{ color: '#006EB3', paddingLeft: 10 }}>
                {nota.observacao_nf}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </Grid>
  );
}
